<template>
  <div class="pop_conditions" style="display:block;">
    <div class="popup_close close_cond close-animate">
      <a href="javascript:void(0);" @click.prevent="$modal.hide('order_timeup')">
        <close/>
      </a>
    </div>
    <div class="pop_frame">
      <h2 class="title25">זמנך עבר...</h2>
      <div class="text">לא ניתן להישאר בעמוד פרטי האשראי זמן ממושך<br />חזרת עמוד אחד אחורה
      </div>
      <!-- <div class="bt_green ease">
                <a href="javascript:void(0);" @click.prevent="$modal.hide('order_timeup')">המשך</a>
              </div> -->
    </div>
  </div>
</template>

<script>
  import Close from "../../assets/img/close.svg";
  export default {
    data() {
      return {
        cost: wpData.shipment_cost
      }
    },
    computed: {
       
    },
    components: {
      Close
    }
  };
</script>

<style scoped>
</style>